import { render, staticRenderFns } from "./powerMachine.vue?vue&type=template&id=a10b0bea"
import script from "./powerMachine.vue?vue&type=script&lang=js"
export * from "./powerMachine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a10b0bea')) {
      api.createRecord('a10b0bea', component.options)
    } else {
      api.reload('a10b0bea', component.options)
    }
    module.hot.accept("./powerMachine.vue?vue&type=template&id=a10b0bea", function () {
      api.rerender('a10b0bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/pfi/powerMachine.vue"
export default component.exports